import { ClickableIcon } from "../../../../../../../components/Icon/ClickableIcon.tsx";

type SelectedTextLayerStyle = {
  isBold: boolean;
  isItalic: boolean;
  isUnderline: boolean;
  isStrikethrough: boolean;
};

export const StyleButtons = ({
  selectedTextLayerStyle,
  setSelectedTextLayerStyle,
}: {
  selectedTextLayerStyle: SelectedTextLayerStyle;
  setSelectedTextLayerStyle: (style: Partial<SelectedTextLayerStyle>) => void;
}) => (
  <div className="flex-row items-center gap-100">
    <ClickableIcon
      size="sm"
      variant="secondary"
      name="Bold"
      className={selectedTextLayerStyle.isBold ? "bg-input-surface-active" : ""}
      onClick={() =>
        setSelectedTextLayerStyle({
          isBold: !selectedTextLayerStyle.isBold,
        })
      }
    />
    <ClickableIcon
      size="sm"
      variant="secondary"
      name="Italic"
      className={
        selectedTextLayerStyle.isItalic ? "bg-input-surface-active" : ""
      }
      onClick={() =>
        setSelectedTextLayerStyle({
          isItalic: !selectedTextLayerStyle.isItalic,
        })
      }
    />
    <ClickableIcon
      size="sm"
      variant="secondary"
      name="Underline"
      className={
        selectedTextLayerStyle.isUnderline ? "bg-input-surface-active" : ""
      }
      onClick={() =>
        setSelectedTextLayerStyle({
          isUnderline: !selectedTextLayerStyle.isUnderline,
        })
      }
    />
    <ClickableIcon
      size="sm"
      variant="secondary"
      name="Strikethrough"
      className={
        selectedTextLayerStyle.isStrikethrough ? "bg-input-surface-active" : ""
      }
      onClick={() =>
        setSelectedTextLayerStyle({
          isStrikethrough: !selectedTextLayerStyle.isStrikethrough,
        })
      }
    />
  </div>
);
